import { Modal, Descriptions, Tag, Divider } from "antd";
import { formatDate } from "../../utils/DateUtils";

const ViewCourseDetailModal = ({ 
  visible, 
  onCancel, 
  course 
}) => {
  if (!course) return null;

  return (
    <Modal
      title="Course Details"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={700}
    >
      <div style={{ padding: "0 24px" }}>
        <Descriptions layout="horizontal" column={1} bordered>
          <Descriptions.Item label="Course Name">
            {course.name || "N/A"}
          </Descriptions.Item>
          
          <Descriptions.Item label="URL-Friendly">
            {course.slug || "N/A"}
          </Descriptions.Item>

          <Descriptions.Item label="Author">
            {course.author || "N/A"}
          </Descriptions.Item>

          <Descriptions.Item label="Status">
            <Tag color={course.isActive ? "success" : "error"}>
              {course.isActive ? "Active" : "Inactive"}
            </Tag>
          </Descriptions.Item>

          <Descriptions.Item label="Price">
            {course.price ? `$${course.price.toFixed(2)}` : "N/A"}
          </Descriptions.Item>

          <Descriptions.Item label="Category">
            {course.category?.name || "N/A"}
          </Descriptions.Item>

          <Descriptions.Item label="Thumbnail">
            {course.imageUrl ? (
              <img
                src={course.imageUrl}
                alt="Course Img"
                style={{ maxWidth: "100%", maxHeight: "150px", borderRadius: "4px" }}
              />
            ) : (
              "No Image available"
            )}
          </Descriptions.Item>
        </Descriptions>

        <Divider>Description</Divider>
        <div style={{ 
          padding: "12px 24px", 
          background: "#f5f5f5", 
          borderRadius: "4px",
          minHeight: "100px",
          wordWrap: "break-word",
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
          width: "100%",
          textAlign: "left"
        }}>
          {course.description && course.description.trim() ? (
            course.description
          ) : (
            <span style={{ fontStyle: 'italic', color: '#888' }}>No description provided</span>
          )}
        </div>

        <Divider>Course Information</Divider>
        <Descriptions layout="horizontal" column={1} bordered>
          <Descriptions.Item label="Total Sections">
            {course.sections?.length || 0}
          </Descriptions.Item>

          <Descriptions.Item label="Created At">
            {formatDate(course.createdAt)}
          </Descriptions.Item>

          <Descriptions.Item label="Last Updated">
            {formatDate(course.updatedAt)}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </Modal>
  );
};

export default ViewCourseDetailModal;